'use client';

import { useIntl } from 'react-intl';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useInstallmentCalculatorTracking } from '../../../../Tracking/hooks/useInstallmentCalculatorTracking/useInstallmentCalculatorTracking';

export type CallToActionButtonProps = Pick<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'className'
> & {
  /**
   * open dialog handler
   */
  openInstallmentCalculatorHandler: () => void;
  /**
   * optional text to override the default button text, useful for AB testing
   */
  text?: string;
};

/**
 * Installment Calculator call to action button
 *
 * renders a text button as call to action to open the installment calculator dialog, used in multiple promotion components
 *
 */

export const CallToActionButton = ({
  openInstallmentCalculatorHandler,
  text,
  className,
}: CallToActionButtonProps) => {
  const { formatMessage } = useIntl();

  const { trackGlycerinLinkClick } = useInstallmentCalculatorTracking();

  return (
    <Button
      variant="textLink"
      type="button"
      className={`text-size-body-sm block${className ? ` ${className}` : ''}`}
      onClick={() => {
        openInstallmentCalculatorHandler();
        trackGlycerinLinkClick();
      }}
    >
      {text ||
        formatMessage({
          id: 'ic.promotion.CallToActionButton.text',
          defaultMessage: 'Wunschrate berechnen',
        })}
      {/* this extends the button click area over the whole component */}
      <span className="absolute inset-0" />
    </Button>
  );
};
